import * as Schema from "effect/Schema";
import { IsoDateTime, ThreadId, TrimmedNonEmptyString } from "./baseSchemas";

export const DevTunnelId = TrimmedNonEmptyString.check(Schema.isMaxLength(128));
export type DevTunnelId = typeof DevTunnelId.Type;

export const DevTunnelRegisterInput = Schema.Struct({
  threadId: ThreadId,
  localHost: TrimmedNonEmptyString,
  localPort: Schema.Number,
  label: Schema.optional(TrimmedNonEmptyString),
});
export type DevTunnelRegisterInput = typeof DevTunnelRegisterInput.Type;

export const DevTunnelRecord = Schema.Struct({
  threadId: ThreadId,
  tunnelId: DevTunnelId,
  publicUrl: TrimmedNonEmptyString,
  localHost: TrimmedNonEmptyString,
  localPort: Schema.Number,
  expiresAt: IsoDateTime,
  label: Schema.optional(TrimmedNonEmptyString),
});
export type DevTunnelRecord = typeof DevTunnelRecord.Type;

export const DevTunnelUnregisterInput = Schema.Struct({
  threadId: ThreadId,
  tunnelId: DevTunnelId,
});
export type DevTunnelUnregisterInput = typeof DevTunnelUnregisterInput.Type;

export const DevTunnelListInput = Schema.Struct({
  threadId: Schema.optional(ThreadId),
});
export type DevTunnelListInput = typeof DevTunnelListInput.Type;

export class DevTunnelError extends Schema.TaggedErrorClass<DevTunnelError>()("DevTunnelError", {
  detail: TrimmedNonEmptyString,
}) {}
